import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import Badge from '../../../components/atoms/Badge';
import { TRACKING_LINK_CATEGORIES, TRANSLATE_PREFIX } from '../../consts';
import DeleteIcon from '../DeleteIcon';
import css from './CategoryCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const CATEGORY_BADGE_CLASS = {
    [TRACKING_LINK_CATEGORIES.DEVICE_LEVEL]: css.badgeDeviceLevel,
    [TRACKING_LINK_CATEGORIES.CAMPAIGN]: css.badgeCampaign,
    [TRACKING_LINK_CATEGORIES.PUBLISHER]: css.badgePublisher,
    [TRACKING_LINK_CATEGORIES.OTHER]: css.badgeOther,
    [TRACKING_LINK_CATEGORIES.CUSTOM]: css.badgeCustom,
};

const CATEGORY_LABEL_KEY = {
    [TRACKING_LINK_CATEGORIES.DEVICE_LEVEL]: `${TAB_PREFIX}.FILTER_DEVICE_LEVEL`,
    [TRACKING_LINK_CATEGORIES.CAMPAIGN]: `${TAB_PREFIX}.FILTER_CAMPAIGN`,
    [TRACKING_LINK_CATEGORIES.PUBLISHER]: `${TAB_PREFIX}.FILTER_PUBLISHER`,
    [TRACKING_LINK_CATEGORIES.OTHER]: `${TAB_PREFIX}.FILTER_OTHER`,
    [TRACKING_LINK_CATEGORIES.CUSTOM]: `${TAB_PREFIX}.CUSTOM_MACRO_LABEL`,
};

const CategoryCell = ({ row, readOnly }) => {
    const {
        category,
        isMandatory,
        deleteConfirmTitleKey,
        deleteConfirmTextKey,
        onConfirmDelete,
        deleteRequiresConfirm,
    } = row;
    const canDelete = !readOnly && !isMandatory;
    return (
        <td className={css.categoryCell}>
            {canDelete && (
                <DeleteIcon
                    className={css.deleteBtn}
                    confirmTitleKey={deleteConfirmTitleKey}
                    confirmTextKey={deleteConfirmTextKey}
                    shouldConfirm={deleteRequiresConfirm}
                    onConfirm={onConfirmDelete}
                />
            )}
            <Badge color={null} className={classNames(css.categoryBadge, CATEGORY_BADGE_CLASS[category])}>
                <Translate id={CATEGORY_LABEL_KEY[category]} />
            </Badge>
        </td>
    );
};

CategoryCell.propTypes = {
    row: PropTypes.shape({
        category: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        isMandatory: PropTypes.bool,
        deleteConfirmTitleKey: PropTypes.string,
        deleteConfirmTextKey: PropTypes.string,
        onConfirmDelete: PropTypes.func,
        deleteRequiresConfirm: PropTypes.bool,
    }).isRequired,
    readOnly: PropTypes.bool,
};

export default CategoryCell;
